module.exports = __webpack_public_path__ + "a6df97324f12c8df8c491ec7b75a8878.png";